<template>
    <section class="container">
        <div class="row">
            <adminSidenav></adminSidenav>
            <div class="col-md-9 ml-sm-auto col-lg-10 px-4">
                <h2>활동 멤버 관리</h2>
                <hr>
                <router-link :to="{name : 'activityShow', params : { id : activity.id }}">{{activity.title}}</router-link>
                <ul>
                    <li>
                        <span>장소 : {{activity.activityPlaceAddress}} {{activity.activityPlaceName}} </span>
                    </li>
                    <li>
                        <span>기간 : {{activity.activityStartDate}} ~ {{activity.activityEndDate}}</span>
                    </li>
                    <li>
                        <span>비용 : {{activity.activityJoinCost}} 원 / 모집인원 : {{activity.joinAblePersonCount}} /  봉사인정시간 : {{activity.volunteerMinute}}분</span>
                    </li>
                </ul>
                <div class="input-group col-sm-12 col-md-6 pull-right my-1">
                    <input type="text" class="form-control" v-model="searchQuery" placeholder="신청자 검색" aria-describedby="button-addon2" >
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" >검색</button>
                    </div>
                    <button class="btn btn-outline-danger" type="button" @click="exportMemberCsv()" >csv 다운로드</button>

                </div>

                <JoinerGrid :heroes="gridData" :activity="activity"
                :columns="gridColumns"
                :filter-key="searchQuery"></JoinerGrid>

            </div>
        </div>
    </section>

</template>

<script>
import adminSidenav from '@/components/admin/Sidenav.vue'
    import JoinerGrid from '@/components/admin/JoinerGrid.vue'
    import { saveAs } from 'file-saver';

    /* eslint-disable */
    export default {
        name: 'activityMemberList',
        data() {
            return {
                searchName:'',
                joiners: [],
                article: {},
                activity:{},

                searchQuery: '',
                gridColumns: ['memberName', 'status', 'description','createdDate', 'isAttendance'],
                gridData: []
            }
        },
        components: {
            adminSidenav, JoinerGrid
        },
        methods: {

            getList() {
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/${this.$route.params.id}/members`;
                //console.log(u);
                this.axios.get(url)
                    .then(function (res) {
                        me.joiners = res.data;
                        me.gridData = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },

            get() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/activity/' + this.$route.params.id)
                    .then(function (res) {
                        me.activity = res.data;
                    }).catch(function (error) {
                    console.log(error);
                    //alert(' 에러');
                });
            },
            exportMemberCsv(){
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/${this.$route.params.id}/members/export`;
                this.axios({
                    url: url,
                    method: 'GET',
                    //responseType: 'blob', // important

                }).then((response) => {
                    let BOM = "\uFEFF";
                    let csvData = BOM + response.data;

                    let blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
                    saveAs(blob, me.$root.$children[0].moment().format('YYYY-MM-DD_') + 'members.csv');
                });
            },
        },
        mounted() {
            this.get();
            this.getList();
        },
        created() {
        },

        watch: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
